<template>
  <div class="page-layout">
    <pace-component />
    <main class="page-layout__main ml-0">
      <AdminHeader></AdminHeader>
      <AdminHeading></AdminHeading>
      <TransitionTemplate>
        <router-view />
      </TransitionTemplate>
      <AdminFooter></AdminFooter>
    </main>
  </div>
</template>

<script>
import AdminHeader from './Header';
import AdminHeading from './Heading';
import AdminFooter from './Footer';
import TransitionTemplate from '../../../components/TransitionTemplate';
import PaceComponent from '../../../components/PaceComponent';

export default {
  name: 'Main',
  components: { PaceComponent, TransitionTemplate, AdminFooter, AdminHeading, AdminHeader },
};
</script>

<style scoped>
.inner-page__lang {
  max-width: 55px !important;
}
</style>
